import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  ISales,
  ISalesListRequest,
  ISalesCreateRequest,
  ISalesUpdateRequest,
  SalesState,
} from "@/types/sales";
import CustomRequest from "../customRequest";

const actions: ActionTree<SalesState, RootState> = {
  async adminGetList({ commit }, params: ISalesListRequest) {
    await CustomRequest.get<IPagination<ISales>>({
      uri: "/sales/sale",
      params,
      commit,
      target: "pagination",
    });
  },

  async adminGet({ commit }, saleId: number) {
    await CustomRequest.get<ISales>({
      uri: `/sales/sale/${saleId}`,
      commit,
      target: "single",
    });
  },

  async adminUpdate(
    { commit },
    datas: { sale_id: number; params: ISalesUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IPagination<ISales>>({
      uri: `/sales/user/${datas.sale_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async adminCreate({ commit }, params: ISalesCreateRequest) {
    const { error } = await CustomRequest.post<IPagination<ISales>>({
      uri: `/sales/user/`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async adminDelete({ commit }, sale_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/user/${sale_id}`,
      flash: true,
    });

    return !error;
  },

  async isUniqueId({ commit }, login_id: number) {
    const { data } = await CustomRequest.get<boolean>({
      uri: `user/is-unique-id/${login_id}`,
    });

    return !!data;
  },

  async isUniqueEmail({ commit }, email: string) {
    const { data } = await CustomRequest.get<boolean>({
      uri: `user/is-unique-email/${email}`,
    });

    return !!data;
  },
};

export default actions;
